var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetflix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_686_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H63.9761V63.9761H0L0 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4191 10.3188L35.4022 19.9092L35.3853 29.4995L34.5962 27.2732C34.596 27.2724 34.595 27.2696 34.5947 27.2688L33.5751 48.6195C34.5776 51.4504 35.1147 52.9617 35.1207 52.9677C35.1286 52.9756 35.6999 53.0101 36.3902 53.0443C38.4818 53.1481 41.0738 53.3705 43.04 53.6148C43.4952 53.6714 43.887 53.7003 43.9106 53.6792C43.9342 53.6581 43.9471 43.8933 43.9392 31.9798L43.9248 10.3188H39.6719H35.4191Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 2.95622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0346 10.29V31.9729C20.0346 43.8986 20.0462 53.6676 20.0605 53.6819C20.0748 53.6962 20.8134 53.6265 21.7017 53.527C22.5901 53.4275 23.8179 53.3037 24.4302 53.2521C25.3691 53.1728 28.1727 52.9925 28.4973 52.9905C28.5917 52.9899 28.5978 52.5027 28.6115 43.8066L28.6259 34.6232L29.3043 36.5425C29.4091 36.8391 29.442 36.9317 29.5441 37.2207L30.5634 15.8753C30.3475 15.2647 30.4607 15.5852 30.2132 14.8854C29.3803 12.5306 28.6736 10.5334 28.6426 10.447L28.5862 10.29H24.3104H20.0346Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 2.95622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0346 10.29L20.0346 22.4613L28.6086 45.2052C28.6095 44.684 28.6105 44.4023 28.6115 43.8066L28.6259 34.6232L29.3043 36.5425C33.0802 47.2268 35.1088 52.9555 35.1207 52.9674C35.1286 52.9753 35.6999 53.0098 36.3903 53.0441C38.4819 53.1478 41.0738 53.3703 43.04 53.6146C43.4952 53.6711 43.887 53.7001 43.9106 53.679C43.9268 53.6644 43.9374 48.8766 43.9402 42.1222L35.4063 17.5872L35.4022 19.9089L35.3853 29.4993L34.5963 27.2729C33.8253 25.0976 33.3105 23.6428 30.2132 14.8854C29.3803 12.5306 28.6736 10.5334 28.6426 10.447L28.5862 10.29H24.3105H20.0346Z",
    fill: "url(#paint0_radial_686_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0347 10.29L28.6259 34.6343V34.6232L29.3043 36.5425C33.0802 47.2268 35.1088 52.9555 35.1207 52.9674C35.1286 52.9753 35.6999 53.0098 36.3902 53.0441C38.4818 53.1478 41.0738 53.3702 43.04 53.6146C43.4929 53.6708 43.8827 53.6997 43.9099 53.6792L35.3853 29.4948V29.4993L34.5962 27.2729C33.8253 25.0976 33.3105 23.6428 30.2132 14.8854C29.3803 12.5306 28.6736 10.5334 28.6426 10.447L28.5862 10.29H24.3104H20.0347Z",
    fill: "#E50914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4191 10.3188L35.4022 19.9092L35.3853 29.4995L34.5962 27.2732C34.596 27.2724 34.595 27.2696 34.5947 27.2688L33.5751 48.6195C34.5776 51.4504 35.1147 52.9617 35.1207 52.9677C35.1286 52.9756 35.6999 53.0101 36.3902 53.0443C38.4818 53.1481 41.0738 53.3705 43.04 53.6148C43.4952 53.6714 43.887 53.7003 43.9106 53.6792C43.9342 53.6581 43.9471 43.8933 43.9392 31.9798L43.9248 10.3188H39.6719H35.4191Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 2.95622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0346 10.29V31.9729C20.0346 43.8986 20.0462 53.6676 20.0605 53.6819C20.0748 53.6962 20.8134 53.6265 21.7017 53.527C22.5901 53.4275 23.8179 53.3037 24.4302 53.2521C25.3691 53.1728 28.1727 52.9925 28.4973 52.9905C28.5917 52.9899 28.5978 52.5027 28.6115 43.8066L28.6259 34.6232L29.3043 36.5425C29.4091 36.8391 29.442 36.9317 29.5441 37.2207L30.5634 15.8753C30.3475 15.2647 30.4607 15.5852 30.2132 14.8854C29.3803 12.5306 28.6736 10.5334 28.6426 10.447L28.5862 10.29H24.3104H20.0346Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 2.95622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0346 10.29L20.0346 22.4613L28.6086 45.2052C28.6095 44.684 28.6105 44.4023 28.6115 43.8066L28.6259 34.6232L29.3043 36.5425C33.0802 47.2268 35.1088 52.9555 35.1207 52.9674C35.1286 52.9753 35.6999 53.0098 36.3903 53.0441C38.4819 53.1478 41.0738 53.3703 43.04 53.6146C43.4952 53.6711 43.887 53.7001 43.9106 53.679C43.9268 53.6644 43.9374 48.8766 43.9402 42.1222L35.4063 17.5872L35.4022 19.9089L35.3853 29.4993L34.5963 27.2729C33.8253 25.0976 33.3105 23.6428 30.2132 14.8854C29.3803 12.5306 28.6736 10.5334 28.6426 10.447L28.5862 10.29H24.3105H20.0346Z",
    fill: "url(#paint1_radial_686_542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0347 10.29L28.6259 34.6343V34.6232L29.3043 36.5425C33.0802 47.2268 35.1088 52.9555 35.1207 52.9674C35.1286 52.9753 35.6999 53.0098 36.3902 53.0441C38.4818 53.1478 41.0738 53.3702 43.04 53.6146C43.4929 53.6708 43.8827 53.6997 43.9099 53.6792L35.3853 29.4948V29.4993L34.5962 27.2729C33.8253 25.0976 33.3105 23.6428 30.2132 14.8854C29.3803 12.5306 28.6736 10.5334 28.6426 10.447L28.5862 10.29H24.3104H20.0347Z",
    fill: "#E50914"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 15.5,
    stroke: "#A18BC4",
    strokeOpacity: 0.73
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_686_542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5905 17.5378) scale(16.8387 16.8387)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_686_542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5905 17.5378) scale(16.8387 16.8387)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_686_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.126031e5f567a219201eb3d2a47a3aff.svg";
export { ForwardRef as ReactComponent };